<template>
  <v-tabs :value="selected" @change="(item) => $emit('change', item)" centered slider-color="accent" color="primary" grow class="br-4">
    <slot></slot>
  </v-tabs>
</template>
<script>
export default {
  props: ['selected']
}
</script>
